import * as THREE from "three";
import Experience from "../Experience";
import { GroundedSkybox } from "three/examples/jsm/objects/GroundedSkybox.js";
import { toneMappingExposure } from "three/src/nodes/TSL.js";

export default class Sky {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.image = this.resources.items.oceanTexture;
    console.log("Sky texture:", this.image);
    this.image.mapping = THREE.EquirectangularReflectionMapping;
    this.image.colorSpace = THREE.LinearSRGBColorSpace;
    this.scene.background = this.image;
    // this.scene.environment = this.image;
    // this.geometry = new THREE.SphereGeometry(1000, 64, 64);
    // this.geometry.scale(1, 1, 1);
    // this.material = new THREE.MeshBasicMaterial({
    //   // color: 0xffffff,
    //   map: this.image,
    //   // side: THREE.DoubleSide,
    // });
    // this.skySphere = new THREE.Mesh(this.geometry, this.material);
    // this.scene.add(this.skySphere);
    // this.skybox = new GroundedSkybox(this.image, {
    //   radius: 200,
    //   height: 10,
    // });
    // this.skybox.position.y = 10;
    // this.skybox.scale.set(100, 100, 100);
    // this.skybox.position.y = 20;
    // this.scene.add(this.skybox);
  }
}
